export const frecuentes = [
  {
    desc: null,
    icon: 'list_alt',
    target: '_blank',
    title: 'CALENDARIO ESCOLAR',
    url: 'https://educacion.sanjuan.edu.ar/mesj/LinkClick.aspx?fileticket=0oj3me4UXxE%3d&tabid=74&mid=1290',
    color: "#C86104"
  },
  /*{
    desc: null,
    icon: 'card_travel',
    target: '_blank',
    title: 'ACTIVIDADES JUNTA',
    url: '?uid=frame-https://educacion.sanjuan.edu.ar/mesj/Prensa/ActividadesJunta.aspx',
    color: "#C86104"
  },*/
  {
    desc: null,
    icon: 'book',
    target: '_blank',
    title: 'CONTRATADOS',
    url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/Contratados.aspx',
    color: "#C86104"
  },
  {
    desc: null,
    icon: 'contacts',
    target: '_blank',
    title: 'JUNTA DE CLASIFICACIÓN',
    url: 'https://archivoseducacion.sanjuan.gob.ar/educacion/consultas.html?c=juntas',
    color: "#C86104"
  },
   {
    desc: null,
    icon: 'contacts',
    target: '_blank',
    title: 'INGRESO A LA DOCENCIA 2026',
    url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/IngresoalaDocencia.aspx',
    color: "#C86104"
  },
  {
    desc: null,
    icon: 'Send',
    target: '_blank',
    title: 'ASIGNACIONES FAMILIARES',
    url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/Asignacionesfamiliares.aspx',
    color: "#C86104"
  }
]